import React from 'react';
import { TextField } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import BaseModal from '../../../../Modal/BaseModal';
import { EditTemplateModalProps } from './types';
import { useEditTemplateModal } from './useEditTemplateModal';
import './EditTemplateModal.scss';

export const EditTemplateModal: React.FC<EditTemplateModalProps> = props => {
  const {
    templateName,
    validationError,
    isSubmitting,
    handleNameChange,
    handleSubmit,
    handleClose,
  } = useEditTemplateModal(props);

  return (
    <BaseModal
      dataTestId="edit-template-modal"
      open={props.open}
      onClose={handleClose}
      title="Edit Template"
      icon={<EditIcon />}
      maxWidth="sm"
      cancelText="Cancel"
      submitText="Save"
      onSubmit={handleSubmit}
      submitDisabled={isSubmitting || !!validationError}
    >
      <div className="editTemplateModalContent">
        <TextField
          label="Template Name"
          value={templateName}
          onChange={e => handleNameChange(e.target.value)}
          error={!!validationError}
          helperText={validationError}
          autoFocus
          fullWidth
          disabled={isSubmitting}
        />
      </div>
    </BaseModal>
  );
};
